import { useContext,createContext, useState, useMemo } from "react";
import SummaryApi from "../common";
import { toast } from "react-toastify";

export const SubContext = createContext();
const SubTransactionProvider = ({children}) =>{
    const [transactions,setTransaction] = useState([]);
    const [isTxLoading,setTxLoading] = useState(true);

    //pagination logic
    const [currentPage,setCurrentPage] = useState(1);
    const [transactionPerpage,setTrasnsactionPerpage] = useState(10);

    const paginatedData = useMemo(()=>{

        // start index 
        const startIndex = (currentPage - 1) * transactionPerpage;
        const endIndex = currentPage * transactionPerpage;
        const totalPages = Math.ceil(transactions.length / transactionPerpage)
        const paginatedTransaction = transactions.slice(startIndex,endIndex);
        
        return {
            startIndex,
            endIndex,
            totalPages,
            paginatedTransaction,
            totalTransaction:transactions.length
        }
    })

    const gotoPage = (pageNo) =>{
        setCurrentPage(pageNo);
    }

    const gotoNext = () =>{
        setCurrentPage((prevPage)=> {
            if(prevPage < paginatedData.totalPages){
                return prevPage + 1;
            }
        })
    }

    const goPrev = () =>{
        setCurrentPage((prevPage)=>{
            if(prevPage > 1){
                return prevPage - 1;
            }
        })
    }


    const getTransactions = async()=>{
        setTxLoading(true);
        try{
            const response = await fetch(SummaryApi.getTransactions.url,{
                method:SummaryApi.getTransactions.method,
                headers:{
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,                
                },                
            })
            const data = await response.json();
            if(!response.ok){
                console.log('failed to fetch transaction',data.message);
                toast.error(data.message);
            }
            // toast.success(data.message);
            console.log(data.transactions);
            setTransaction(data.transactions || [])
        }catch(err){
            console.log('error fetching transaction');

        }finally{
            setTxLoading(false);
        }
    }
    return (
        <SubContext.Provider value={{
            getTransactions,
            allTransaction:transactions,
            isTxLoading,
            startIndex:paginatedData.startIndex,
            endIndex:paginatedData.endIndex,
            paginatedTransaction:paginatedData.paginatedTransaction,
            totalPages:paginatedData.totalPages,
            totalTransaction:paginatedData.totalTransaction,
            gotoPage,
            gotoNext,
            goPrev,
            currentPage,
            }}>
            {children}
        </SubContext.Provider>
    )
}

export default SubTransactionProvider;